import type { HTMLChakraProps } from '@chakra-ui/react-v2';
import { forwardRef } from '@chakra-ui/react-v2';
import { chakra } from '@chakra-ui/react-v2';

import { Skeleton, SkeletonText } from '@frontend/legacy-components';

import { useConversationStyles } from '../useConversationStyles';

export type ConversationSkeletonProps = HTMLChakraProps<'div'>;

/**
 * Skeleton for the Conversation component.
 * Displays a skeleton UI while conversation content is loading.
 */
export const ConversationSkeleton: React.FC<ConversationSkeletonProps> =
  forwardRef<ConversationSkeletonProps, 'div'>(({ ...props }, ref) => {
    const { skeleton } = useConversationStyles();

    return (
      <chakra.div
        ref={ref}
        id="conversation-loading-container"
        sx={skeleton}
        className="conversation-skeleton"
        {...props}
      >
        <Skeleton h={5} mx={0} borderRadius="md" flexShrink={0} />
        <SkeletonText noOfLines={6} mx={1.25} spacing={1.5} flexShrink={0} />
      </chakra.div>
    );
  });
ConversationSkeleton.displayName = 'ConversationSkeleton';
